module.exports = __webpack_public_path__ + "img/c06_unitoxcart_Normal_ua.fbe04c38.webp";